module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    attrs: {
      "id": "layout"
    }
  }, [_c('div', {
    staticClass: "wrapper centered",
    class: {
      'nav-open': _vm.navOpened
    }
  }, [_c('sidebar', {
    attrs: {
      "open": _vm.navOpened
    }
  }), _c('div', {
    staticClass: "main-panel",
    class: {
      'loading': _vm.loading
    }
  }, [_c('navigation', {
    on: {
      "toggleSideBar": _vm.toggleSideBar
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container container-fluid"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._t("default")], 2)])]), _c('md-footer'), (_vm.navOpened) ? _c('div', {
    staticClass: "close-layer",
    on: {
      "click": _vm.onCloseLayerClick
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81d66b40","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/docs.vue
// module id = 5bQb
// module chunks = 13 14